var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeboxlogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "484px",
    height: "701px",
    viewBox: "0 0 484 701",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M536.2,634.158997 L536.2,405.591726 L716.248,315.866915 C724.461831,311.753592 729.653199,303.325723 729.653199,294.104393 C729.653199,284.883063 724.461831,276.455194 716.248,272.341871 L522.648,175.079203 L522.648,175.079203 C521.077735,173.903559 519.371256,172.923767 517.566,172.161322 C515.716842,171.946226 513.849158,171.946226 512,172.161322 L512,172.161322 L508.854,172.161322 C507.084734,171.964579 505.299266,171.964579 503.53,172.161322 C502.175284,172.769964 500.879158,173.50252 499.658,174.349733 C498.28404,175.112998 496.987263,176.008794 495.786,177.024456 C494.593191,178.285304 493.538486,179.671125 492.64,181.158119 C491.847862,181.99319 491.119782,182.887319 490.462,183.832843 L490.462,183.832843 C489.893001,185.407673 489.487514,187.037376 489.252,188.695976 C488.348218,191.192535 487.857718,193.821035 487.8,196.47699 C487.8,196.47699 487.8,196.47699 487.8,196.47699 L487.8,731.421665 C487.8,744.850837 498.634709,755.737332 512,755.737332 C525.365291,755.737332 536.2,744.850837 536.2,731.421665 L536.2,682.790331 C646.068,687.410307 705.6,723.883808 705.6,743.093185 C705.6,762.302562 637.356,804.368666 512,804.368666 C386.644,804.368666 318.4,764.247815 318.4,743.579498 C318.4,729.962725 349.86,704.674431 419.798,691.057657 C433.16329,688.506114 441.939404,675.551186 439.399999,662.122014 C436.860594,648.692842 423.967291,639.874781 410.602,642.426323 C322.514,660.419917 270,697.866044 270,743.579498 C270,816.526499 391,853 512,853 C633,853 754,815.310716 754,743.579498 C754,676.468257 648.004,639.508443 536.2,634.158997 Z M536,236 L651,294.121086 L536,352 L536,236 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.1%",
    y: "-1.5%",
    width: "104.1%",
    height: "105.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 20,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.57254902   0 0 0 0 0.803921569   0 0 0 0 0  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-270.000000, -172.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(512.000000, 512.500000) scale(-1, 1) translate(-512.000000, -512.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeboxlogoWhite);
export default __webpack_public_path__ + "static/media/teeboxlogo_white.9d152a821b07d9402066f67695d56c89.svg";
export { ForwardRef as ReactComponent };